import React, { Suspense, useEffect } from 'react';
import Layout from 'components/Layout/Layout';
import Loader from 'components/Loader/Loader';
import routes from 'routes';
import RenderRoutes from 'components/RenderRoutes/RenderRoutes';
import runDatadog from 'datadogConfig';

const App = () => {
  const isProduction = process.env.NODE_ENV === 'production';

  useEffect(() => {
    if (isProduction) {
      runDatadog();
    }
  }, [isProduction]);

  return (
    <div>
      <Layout>
        <Suspense fallback={<Loader />}>
          <RenderRoutes routes={routes} />
        </Suspense>
      </Layout>
    </div>
  );
};

export default App;
